<template>
  <div class="contentHome">
    <div class="banner">
      <swiper ref="mySwiper" :options="swiperOption">
        <swiper-slide v-for="(item,index ) in banners" :key="index">
          <div class="slideUser">
            <div v-if="item.bannerType==1" @click="openWindow(item.imgUrl)" class="swiperImg"
                 :style="'backgroundImage: url('+item.imgPath+')'"></div>
            <div v-if="item.bannerType==2" class="swiperImg">
              <video style="height: 100%;width: 100%" controls :poster="item.videoPoster">
                <source :src="item.videoPath"/>
              </video>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="maskImg" v-if="!question">
        <div v-for="(item,index) in question" :key="index" class="flex">
          <img :src="item.img" alt="" width="51">
          <div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>
    <!--        医生介绍-->
    <div class="doctor">
      <div class="userCon">
        <div class="flex">
          <div v-if="detail.headImgPath" :style="'backgroundImage: url('+detail.headImgPath+')'" class="userImg"></div>
          <div v-else class="userImg default-headImg" :gender="detail.gender"></div>
          <div class="userInfo">
            <div class="leftMo">
              <div class="flex">
                <h2>{{ detail.fullName }} {{ detail.enName }}</h2>
                <span class="workYear">从业<strong>{{ workYear }}</strong>年</span>
              </div>
              <p v-if="detail.signature" class="motto" :title="detail.signature">“{{ detail.signature }}”</p>
              <p><strong>咨询专科：</strong>{{ detail.professional }}</p>
              <p><strong>专业擅长：</strong>{{ detail.skill }}</p>
              <p><strong>教育背景：</strong>{{ detail.eduBackground }}</p>
              <p><strong>资质认证：</strong>{{ detail.technicalTitle }}{{ detail.certSource ? detail.certSource : '-' }}</p>
              <p><strong>目前任职：</strong>{{ detail.company }}{{ detail.department }}{{ detail.job }}</p>
              <div class="doctorPrice">
                <span class="initialCharge">
                  <template v-if="detail.isOpenAppoint===0">预约即将开启</template>
                  <template v-else>{{ detail.initialCharge }}元 / {{ detail.initialMinute }}分钟</template>
                </span>
                <span v-if="detail.specialNote" class="note">（{{ detail.specialNote }}）</span>
                <span class="language-tag"
                      :style="{display:(detail.specialNote?'block':'inline-block')}">{{ languageTags.join('/') }}</span>
              </div>
              <div class="btnGroup" v-if="userType===1||userType===0">
                <el-button class="scale02" @click="toConsultation(detail.account)" v-if="detail.isOpenAppoint===1">我要咨询
                </el-button>
                <!--<el-button class="scale02"  v-if="userType===1">关注TA</el-button>-->
                <el-button class="scale02" @click="changeState" :class="{ 'cancelAtt' : flag}" v-if="userType===1">
                  {{ flag ? "取消关注" : "关注TA" }}
                </el-button>
                <el-button class="scale02 btn_a" @click="createMessage">私信</el-button>
                <el-button class="scale02 btn_a" @click="openShare">医生分享</el-button>
              </div>
              <div class="btnGroup" v-if="userType===2 && curUid != detail.doctorId">
                <el-button class="scale02 btn_a" @click="createMessage">私信</el-button>
              </div>
            </div>
            <div class="cumulative">
              <p>已咨询</p>
              <span>{{ detail.consultationCount }}</span>人
              <p>所在地</p>
              <!--  <div>{{ detail.country }}</div>  -->
              <span>{{ detail.province }}</span>
              <span class="city">{{ detail.abodeCity }}</span>
              <!-- <span class="city">{{ detail.district }}</span>  -->
            </div>
          </div>
        </div>
        <div class="achievement">
          <div v-if="honors.length > 0">
            <h3>荣誉成就</h3>
            <p class="honor-list">
              <span class="honor-item" v-for="(obj,index) in honors" :key="'honors_'+index">{{ obj }} </span>
            </p>
          </div>
          <div v-if="detail.briefDesc">
            <h3>简历</h3>
            <p style="white-space: pre-line;">{{ detail.briefDesc }}</p>
          </div>

        </div>
      </div>
    </div>
    <!--        咨询专长-->
    <div class="expertise" v-if="indicationList.length != 0">
      <div class="userCon flex">
        <span class="title">咨询专长</span>
        <div class="typeExpertise flex">
          <template v-for="(obj,i) in indicationList">
            <div :key="i" class="typeList" :style="'backgroundImage: url('+obj.thumbnailPath+')'">
              <p class="tit"> {{ obj.cnName }}</p>
              <div class="hover">
                <strong>{{ obj.cnName }}</strong>
                <el-button class="detail">
                  <router-link :to="'/serviceType?id='+obj.id">了解详情</router-link>
                </el-button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!--    新闻资讯-->
    <div class="doctorNews">
      <div class="userCon flex">
        <div class="doctorN">
          <div v-if="article.thumbnailPath" class="NewsImg"
               :style="'backgroundImage: url('+article.thumbnailPath+')'"></div>
          <div v-else class="NewsImg" style="background-image:url('/static/default_imgs/news.jpg')"></div>

          <div class="topLeft"></div>
          <div class="bottom" style="display: none">
            <p>
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="line"></span>
              <span class="dot"></span>
            </p>
          </div>
        </div>
        <div class="list">
          <div class="title">
            <h1>新闻资讯</h1><img src="../../assets/img/more.png" alt="" width="41">
          </div>
          <div class="detail">
            <h3 class="tit">{{ article.title }}</h3>
            <div class="time flex">
              <div class="flex">
                <span class="line"></span>
                <span class="dot"></span>
                <span class="dot"></span>
                {{ article.publishDate }}
              </div>
            </div>
            <p class="content">{{ article.summary }}</p>
            <div class="btnGroup">
              <!--<router-link :to="'/newsDetail?id='+article.id" class="more">了解详情</router-link>-->
              <el-button class="scale02" @click="$router.push({path:'/newsDetail?id='+article.id})">了解详情
              </el-button>
              <el-button class="scale02" @click="$router.push('/news')">查看更多</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--        学术研究-->
    <div class="academic">
      <div class="userCon">
        <div class="flex title">
          <div class="flex">
            <h1>每日研究</h1><img src="../../assets/img/more.png" alt="" width="41">
          </div>
        </div>
        <div class="flex ach">
          <div v-for="(item,index) in researchs.slice(0,3)" :key="index" class="academicList">
            <router-link :to="'/studyDetail?id='+item.id">
              <div :style="'backgroundImage: url('+item.thumbnailPath+')'" class="img"></div>
              <h4>{{ item.title }}</h4>
              <p>{{ item.summary }}</p>
              <a href="javascript:void(0);" class="flex">READ MORE
                <div class="readMore"></div>
              </a>
            </router-link>
          </div>
          <div class="historyAch" v-if="researchs>3">
            <div class="historyResech">
              <router-link :to="'/studyDetail?id='+item.id" v-for="(item,index) in researchs.slice(3,7)"
                           :key="index" class="list">
                {{ item.title }}
              </router-link>
            </div>
            <a href="/study" class="moreLibrary">
              <img src="../../assets/img/library_a.png" alt="" width="13">
              研究文库
            </a>
          </div>
        </div>
      </div>
    </div>

    <!--新药-->
    <div class="medicine">
      <div class="userCon">
        <div class="flex title">
          <div class="flex">
            <h1>专业新药</h1><img src="../../assets/img/more.png" alt="" width="41">
          </div>
        </div>
        <div class="flex ach">
          <div class="drug-block-left">
            <div class="item drug-thumbnail">
              <swiper ref="drugSwiper" :options="drugSwiperOptions">
                <swiper-slide v-for="drug in drugs_left" :key="drug.id">
                  <img class="drug-img" :src="drug.thumbnailPath">
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
            <div class="item brief-desc">
              <h3 style="margin-bottom: 20px">
                <span style="margin-right: 20px;">{{ curDrugSlide.cnName }}</span>
                <span>{{ curDrugSlide.enName }}</span>
              </h3>
              <p>{{ curDrugSlide.briefDesc }}</p>
            </div>

          </div>

          <div class="historyAch">
            <div class="historyResech">
              <router-link to="/medication" v-for="(item,index) in drugs_right"
                           :key="index" class="list">
                {{ item.cnName }}
              </router-link>
            </div>
            <a href="/medication" class="moreLibrary">
              <img src="../../assets/img/library_b.png" alt="" width="13">
              精神学药库
            </a>
          </div>
        </div>
      </div>
    </div>
    <loginDialog ref="loginDialog"></loginDialog>
    <!--分享-->
    <share ref="shareDia" :user="detail" :indicationList="indicationList" :workYear="workYear"></share>

    <!-- share_coupon -->
    <el-dialog :visible.sync="share_visible"
               title="优惠券领取"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="300px">
      <div class="coupon">
        <div class="borderCou">
          <div class="name">{{ share_coupon.couponTitle }}</div>
          <template v-if="share_coupon.couponType == 1">
            <h4 class="discount">{{ share_coupon|couponDiscountFmt }}</h4>
            <p class="stackable">{{ (share_coupon.stackable == 0 ? '不' : '') + '可叠加' }}</p>
          </template>
          <template v-else>
            <div class="discount">{{ share_coupon.couponType == 2 ? '月卡' : '年卡' }}</div>
            <p class="title">可用{{ share_coupon.useLimitCount }}次</p>
          </template>
          <p class="time">有效期至：{{ new Date(share_coupon.endUseDate).Format('yyyy.MM.dd') }}</p>
        </div>
        <div class="op-gain" v-if="share_coupon.couponType ==1" @click="gainCoupon(share_coupon.id)">领取</div>
        <div class="op-gain" v-else @click="couponPay(share_coupon.id)">购买</div>
      </div>
    </el-dialog>

    <!-- share_coupon: pay dialog -->
    <el-dialog
        class="purchase" center
        top="0"
        :visible.sync="couponPayDialog.visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="closeCouponPay"
        width="600px">
      <div class="code">
        <div class="flex qr-img" v-loading="couponPayDialog.qrLoading">
          <img :src="couponPayDialog.qrImgSrc" alt="">
        </div>
        <p class="count-down" v-if="!couponPayDialog.qrLoading">{{ couponPayDialog.expireText }}</p>
        <p>微信支付</p>
      </div>
      <div class="purchaseInfo">
        <h2 class="couponType">{{ share_coupon.couponType == 2 ? '月卡' : '年卡' }}购买</h2>
        <p class="tit">可预约咨询{{ share_coupon.useLimitCount }}次</p>
        <p class="tit">有效日期：{{ new Date(share_coupon.startUseDate).Format('yyyy-MM-dd HH:mm:ss') }}</p>
        <p class="tit">结束日期：{{ new Date(share_coupon.endUseDate).Format('yyyy-MM-dd HH:mm:ss') }}</p>
        <div class="tit flex">支付金额：<h2>￥{{ (share_coupon.price / 100).toFixed(2) }}</h2></div>
        <div class="text">说明：{{ share_coupon.couponExplain }}</div>
      </div>
    </el-dialog>

    <!-- 好友申请弹窗 -->
    <el-dialog class="buddy"
               top="0"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="friendApplyDialog.show"
               width="340px" >
      <template slot="title">
        <span>好友申请</span>
      </template>
      <div v-if="friendApplyDialog.form.name" style="font-size: 14px; font-weight: bold;margin-bottom: 8px">
        请求添加“{{friendApplyDialog.form.name}}”为好友
      </div>
      <el-input v-model="friendApplyDialog.form.reason" type="textarea" rows="4" placeholder="请输入请求内容"></el-input>
      <template slot="footer">
        <el-button type="primary" @click="sendFriendApply" :loading="friendApplyDialog.btnLoad">发送申请</el-button>
        <el-button style="margin-left: 18px" @click="friendApplyDialog.show=false">取消</el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import SysCons from '@/api/common'
import {directive, Swiper, SwiperSlide} from 'vue-awesome-swiper'
import loginDialog from "../loginDialog";
import share from "../consult/share";

require("swiper/dist/css/swiper.css");

export default {
  name: "index",
  data() {
    let that = this;
    return {
      banners: [],
      swiperOption: {
        initialSlide: 0,
        slidesPerView: 1,
        autoplay: true,
        speed: 2000,
        loop: true,
        observer: true,
        observeParents: true,
      },
      question: [],//
      researchs: [],// 学术研究
      indicationList: [],// 咨询专长
      // drugs: [],// 新药
      program: [],//

      detail: {},// 医生详情
      type: [],
      article: {},// 文章
      workYear: 0,// 从业年龄

      userType: 1,//用户类型:1是普通用户,2是医生
      addUserConcernUrl: SysCons.api.user.addUserConcern,//用户关注医生url
      deleteUserConcernUrl: SysCons.api.user.deleteUserConcern,//用户取消关注医生url
      getUserConcernUrl: SysCons.api.user.getUserConcern,//用户是否关注了医生url

      flag: false,

      consultation: {},
      lecture: {},

      drugs_left: [],
      drugs_right: [],
      curDrugSlide: {},
      drugSwiperOptions: {
        observer: true,
        observeSlideChildren: true,
        pagination: '.swiper-pagination',
        paginationClickable: true,
        slidesPerView: 1,
        loop: true,
        speed: 1000,
        autoplay: 3000,
        onSlideChangeStart: function (swiper) {
          that.curDrugSlide = that.drugs_left[swiper.activeIndex];
        }
      },

      share_id: this.$route.query.share_id,
      share_coupon: {},
      share_visible: false,

      couponPayDialog: {
        visible: false,
        qrImgSrc: '',
        qrLoading: false,
        expire: 0, // 二维码有效期
        expireTimer: 0, //倒计时
        timeDelayer: 0, // 延时请求
        expireText: '00:00',
        //couponInfo: {},
        payCouponNo: '', // 二维码对应订单
      },

      languageTags: [], // 语言标签
      curUid: localStorage.getItem('curUid'),
      // 好友申请弹窗
      friendApplyDialog: {
        show: false,
        btnLoad: false,
        form: {
          id: '',
          name: '',
          reason: ''
        }
      }
    }
  },
  inject: ['reload'],
  beforeCreate() {
    if (SysCons.utils.isMobileWeb() || SysCons.utils.isWechatClient()) {
      // 查询参数
      let params = location.search; // 优惠券分享ID
      let url = SysCons.h5_url + '/doctorDetail/' + this.$route.params.account + params;
      location.href = url;
      return;
      // TODO 手机端优惠券分享逻辑: 领取、购买等
    }
  },
  async mounted() {
    let user = await SysCons.utils.getCurrent();
    let that = this;
    if (user == null) {//如果没登陆
      this.userType = 0;
    } else {
      this.getUserConcernMethod();
      this.userType = user.type;
    }
    this.getData(); // 20210408: 增加语言标签内容
    this.$ajax.get(SysCons.api.recommend.drug_fresh).then(res => {
      if (res.data.status === 'success') {
        let length = res.data.list.length;
        if (length <= 3) {
          this.drugs_left = res.data.list;
          this.drugs_right = res.data.list;
        } else if (length <= 7) {
          this.drugs_left = res.data.list.slice(0, 3);
          this.drugs_right = res.data.list.slice(3, length);
        } else {
          this.drugs_left = res.data.list.slice(0, length - 4);
          this.drugs_right = res.data.list.slice(length - 4, length);
        }
        this.curDrugSlide = this.drugs_left[0];
      }
    });

    // 优惠券领取
    if (that.share_id) {
      // share_id是否有效
      that.$ajax.post(SysCons.basePath + 'coupon/coupon-rule/valid/' + that.share_id).then(res => {
        if (res.data.status === 'success') {
          // 获取信息展示
          that.share_coupon = res.data.data;
          that.share_visible = true;
        }
      });
    }

  },
  methods: {
    showApplyDialog(userId,userName){
      this.friendApplyDialog.form.id = userId;
      this.friendApplyDialog.form.name = userName;
      this.friendApplyDialog.btnLoad = false;
      this.friendApplyDialog.show = true;
    },
    sendFriendApply(){
      let userId = this.friendApplyDialog.form.id;
      if(!userId){ return; }
      let greetContent = this.friendApplyDialog.form.reason;
      if($.trim(greetContent).length===0){
        this.$message.error('好友申请内容不能为空');return;
      }
      this.friendApplyDialog.btnLoad = true;
      this.$ajax.post(SysCons.api.communication.chat.applySubmit.replace('{id}', userId), {greetContent}).then(res=>{
        this.friendApplyDialog.btnLoad = false;
        if(res.data.status === 'success'){
          this.$message.success('已发送');
          this.friendApplyDialog.show = false;
        }else{
          this.$message.error(res.data.message);
        }
      }).catch(err=>{
        this.$message.error('error');
        this.friendApplyDialog.btnLoad = false;
      });
    },
    openShare() {
      let that = this;
      that.$refs.shareDia.dialogVisible = true;
      that.$nextTick(() => {
        that.$refs.shareDia.initShare();
      });
    },
    openWindow(url) {
      if (url) {
        window.open(url);
      }
    },
    getData() {
      let account = this.$route.params.account, vm = this;
      vm.$ajax.post(SysCons.api.doctor.index.replace('{account}', account))
          .then((res) => {
            if (res.data.status == 'success') {
              vm.banners = res.data.data.banners || [];
              vm.detail = res.data.data.detail || {};
              vm.article = res.data.data.article || {};
              //vm.researchs = res.data.data.researchs || [];
              let researchList = res.data.data.researchs || [];
              vm.loadResearch(researchList);
              // vm.drugs = res.data.data.drugs || [];
              vm.workYear = res.data.data.workYear || 0;
              // 过多的列表会显示错乱: 限制6个
              vm.indicationList = res.data.data.indicationList || [];
              if (vm.indicationList.length > 6) {
                vm.indicationList.splice(5, vm.indicationList.length - 6)
              }
              // 语言
              vm.$ajax.get(SysCons.basePath + 'auth/doctor-tags/language/' + res.data.data.detail.doctorId).then(res => {
                if (res.data.status === 'success') {
                  if (res.data.list && res.data.list.length > 0) {
                    for (let tag of res.data.list) {
                      vm.languageTags.push(tag.tagName);
                    }
                  }
                }
              });

            }
          })
      document.querySelector('.homeIndex').scrollTop = 0;//回到顶部
    },
    //我要咨询
    toConsultation(id) {
      if (!this.userType) {
        // 未登录
        this.$refs.loginDialog.dialogVisible = true;
        this.$refs.loginDialog.reloadCode('vcode-user');
        this.$refs.loginDialog.successUrl = '/order/' + this.$route.params.account;
      } else if (this.type === 2) {
        this.$message.error("医生不允许预约");
      } else {
        //sessionStorage.removeItem('choosed');
        this.$router.push({path: '/order/' + this.$route.params.account});
      }

      //this.$router.push({path: '../../doctorDetail/' + id})
    },
    //用户是否关注了该医生
    getUserConcernMethod() {
      let that = this;
      this.$ajax.get(this.getUserConcernUrl.replace("{account}", this.$route.params.account))
          .then(function (res) {
            if (res.data.status === 'success') {
              that.flag = res.data.concern;
              that.doctorId = res.data.id;
            } else {
              that.$router.back();
            }
          })
    },
    //关注TA
    addUserConcernMethod() {
      let that = this;
      this.$ajax.post(this.addUserConcernUrl.replace("{doctorId}", this.doctorId))
          .then(function (res) {
            if (res.data.status === 'success') {
              that.$message.success('关注成功');
            } else {
              that.$message.warning('关注失败')
            }
          }).catch((err) => {
        console.error(err);
        that.$message.error('操作失败');
      })
    },
    //取消关注
    deleteUserConcernMethod() {
      let that = this;
      this.$ajax.post(this.deleteUserConcernUrl.replace("{doctorId}", this.doctorId))
          .then(function (res) {
            if (res.data.status === 'success') {
              that.$message('取消关注了' + that.detail.fullName)
            } else {
              that.$message.warning('取消关注' + that.detail.fullName + '失败')
            }
          }).catch((err) => {
        console.error(err);
        that.$message.error('操作失败');
      })
    },
    changeState() {
      this.flag = !this.flag;
      this.flag ? this.addUserConcernMethod() : this.deleteUserConcernMethod();
    },
    loadResearch(list) {
      let emptyImg = [];
      let that = this;
      $(list).each((i, o) => {
        if (!o.thumbnailPath) {
          emptyImg.push(i);
        }
      });
      if (emptyImg.length > 0) {
        this.$ajax.get(SysCons.api.dict.article.research).then(res => {
          if (res.data.status === 'success') {
            let typeMap = new Map();
            $(res.data.list).each((i, o) => {
              typeMap.set(o.id, o);
            });
            // 2. 加载研究信息
            emptyImg.forEach((index) => {
              if (list[index].pageType) {
                list[index].thumbnailPath = typeMap.get(list[index].pageType).itemIcon;
              }
            });
            that.researchs = list;
          }
        });
      }
    },
    createMessage() {
      if (!this.userType) {
        // 未登录
        this.$refs.loginDialog.dialogVisible = true;
        this.$refs.loginDialog.reloadCode('vcode-user');
        this.$refs.loginDialog.successUrl = '/order/' + this.$route.params.account;
        return;
      }

      if (this.doctorId) {
        this.$ajax.post(SysCons.api.communication.chat.create.replace('{uid}', this.doctorId)).then(res => {
          if (res.data.status === 'success') {
            if (res.data.userType == 1) {
              this.$router.push({name: 'communicate', params: {id: res.data.id}});
            } else if (res.data.userType == 2) {
              this.$router.push({name: 'communicateDoc', params: {id: res.data.id}});
            } else {
              this.$message.error('error');
            }
          } else {

            if(res.data.status === 'needApply'){
              this.showApplyDialog(this.doctorId,this.detail.fullName);
            }
            this.$message.error(res.data.message);
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('失败');
        })
      }
    },
    gainCoupon(couponId) { // 领取优惠券
      if (!couponId) {
        return;
      }
      if (!this.userType) {
        // 未登录
        this.$refs.loginDialog.dialogVisible = true;
        this.$refs.loginDialog.reloadCode('vcode-user');
        this.$refs.loginDialog.successUrl = '/order/' + this.$route.params.account;
        return;
      } else if (this.userType != 1) {
        this.$message.info('不允许领取');
        this.share_visible = false;
        return;
      }
      this.$ajax.post(SysCons.basePath + 'coupon/coupon-rule/authorize/receive/self/' + couponId).then(res => {
        if (res.data.status === 'success') {
          this.$message.success('领取成功');
        } else {
          this.$message.error(res.data.message);
        }
        this.share_visible = false;
      }).catch(err => {
        this.$message.error('操作失败');
        this.share_visible = false;
      })
    },
    couponPay(couponId) {
      if (!this.userType) {
        // 未登录
        this.$refs.loginDialog.dialogVisible = true;
        this.$refs.loginDialog.reloadCode('vcode-user');
        this.$refs.loginDialog.successUrl = '/order/' + this.$route.params.account;
        return;
      } else if (this.userType != 1) {
        this.$message.info('不允许领取');
        this.share_visible = false;
        return;
      }
      let that = this;
      that.couponPayDialog.qrLoading = true;
      // that.couponPayDialog.couponInfo = item;
      that.couponPayDialog.visible = true;
      // 获取付款码
      that.couponPayDialog.timeDelayer = setTimeout(() => {
        if (!that.couponPayDialog.visible) {
          clearTimeout(that.couponPayDialog.timeDelayer);
          return;
        }
        that.$ajax.post(SysCons.basePath + 'coupon/pay/authorize/pay/' + couponId + '/native').then(res => {
          if (res.data.status === 'success') {
            that.couponPayDialog.qrImgSrc = res.data.url; //5min内有效
            that.couponPayDialog.payCouponNo = res.data.token;
            that.couponPayDialog.expire = res.data.expire; //单位:s

            that.couponPayDialog.qrLoading = false;
            // 定时
            that.couponPayDialog.expireTimer = setInterval(() => {
              if (!that.couponPayDialog.visible) {
                clearInterval(that.couponPayDialog.expireTimer);
                return;
              }
              that.couponPayDialog.expireText = SysCons.utils.secondToDate(that.couponPayDialog.expire);
              that.couponPayDialog.expire--;
              if (that.couponPayDialog.expire < 0) {
                // 倒计时结束
                clearInterval(that.couponPayDialog.expireTimer);
                that.closeCouponPay();
                return;
              }
              // 轮询订单状态 3s间隔
              if (that.couponPayDialog.expire > 0) {
                if (!(that.couponPayDialog.expire % 3 == 0)) {
                  return;
                }
              }
              that.$ajax.post(SysCons.basePath + 'coupon/pay/authorize/isPay/' + res.data.token).then(pollingRes => {
                if (pollingRes.data.status === 'success') {
                  if (pollingRes.data.data == 1) {
                    // 已支付
                    that.closeCouponPay();
                    that.$message.success('支付成功');
                    setTimeout(() => {
                      that.toConsultation(that.detail.account);
                    }, 1666);
                  }
                } else {
                  that.$message.error('支付订单错误');
                  that.closeCouponPay();
                }
              }).catch(() => {
                that.$message.error('支付订单错误');
                that.closeCouponPay();
              });
            }, 1000);
          }
        }).catch(() => {
          that.closeCouponPay();
          that.$message.error('获取数据失败');
        });
      }, 2000);
    },
    closeCouponPay() {
      let that = this;
      clearTimeout(that.couponPayDialog.timeDelayer);
      clearInterval(that.couponPayDialog.expireTimer);
      that.couponPayDialog.payCouponNo = '';
      that.couponPayDialog.qrImgSrc = '';
    },
  },
  filters: {
    indicationFmt(indications) {
      if (indications) {
        let skills = [];
        $(indications).each((i, o) => {
          if (o && o.cnName) {
            skills.push(o.cnName);
          }
        });
        return skills.join("、");
      }
      return '-';
    },
    couponDiscountFmt(item) {
      if (item.discountMode == 1) { //折扣
        return item.discountRate / 10 + '折';
      } else if (item.discountMode == 2) { //定额
        return '￥' + item.discountAmount / 100;
      }
      return '0';
    }
  },
  components: {
    Swiper,
    SwiperSlide,
    loginDialog,
    share
  },
  directives: {
    swiper: directive
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    },
    swiper_drug() {
      return this.$refs.drugSwiper.$swiper
    },
    honors() {
      let honors = null;
      if (this.detail.honors) {
        honors = JSON.parse(this.detail.honors)
      }
      return honors || [];
    }
  },

}
</script>

<style scoped lang="scss">
@import '../../assets/css/doctorIndex.scss';

.note {
  font-size: 17px;
  color: #FF0034;
}
.buddy ::v-deep {
  .el-dialog {
    margin-bottom: 0;
  }
  .el-dialog__header {
    font-size: 16px;
    font-family: Microsoft YaHei UI;
    font-weight: bold;
    color: #567BFF;
    border-bottom: 1px solid rgba(187, 187, 187, 0.5);
    span {
      border-bottom: 2px solid #567BFF;
      padding-bottom: 10px;
    }
  }
  .el-dialog__body {
    padding: 15px 20px;
  }
  .el-dialog__close {
    border: 1px dashed #567BFF;
    color: #567BFF;
    font-size: 18px;
  }
  button{
    padding: 0 12px;
    height: 34px;
    line-height: 34px;
  }
}
</style>
